import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'
import { Icon, IconButton, Link, Menu, MenuItem } from '@material-ui/core'
import { useReactiveVar } from '@apollo/client'
import { appSubdomainVar, isUserLoggedInVar } from '../../graphql/stores/local'
import { SCHOOL_LEIDERCHAP_SUBDOMAIN_NAME } from '../../constants'
import * as internalRoutes from '../../constants/internaRoutes'

const listRoutes = [
  { href: internalRoutes.list.schools, title: 'View schools' },
  { href: internalRoutes.list.answers, title: 'View answers' },
  { href: internalRoutes.list.questions, title: 'View questions' },
  { href: internalRoutes.list.sessions, title: 'View sessions' },
  { href: internalRoutes.list.forms, title: 'View forms' },
  {
    href: internalRoutes.list.groups,
    title: 'Groepen',
    subDomain: SCHOOL_LEIDERCHAP_SUBDOMAIN_NAME,
  },
  {
    href: internalRoutes.list.statisticGroups,
    title: 'Statistiek groepen',
    subDomain: SCHOOL_LEIDERCHAP_SUBDOMAIN_NAME,
  },
  {
    href: internalRoutes.list.schoolleaders,
    title: 'Schoolleiders',
    subDomain: SCHOOL_LEIDERCHAP_SUBDOMAIN_NAME,
  },
  {
    href: internalRoutes.list.schoolleaderDashboard,
    title: 'View global reporting',
    subDomain: SCHOOL_LEIDERCHAP_SUBDOMAIN_NAME,
  },
  {
    href: internalRoutes.list.quicScanParticipants,
    title: 'View quick scan participants',
    subDomain: SCHOOL_LEIDERCHAP_SUBDOMAIN_NAME,
  },
  {
    href: internalRoutes.list.anonymousSchoolleaders,
    title: 'Preregistraties schoolleiders',
    subDomain: SCHOOL_LEIDERCHAP_SUBDOMAIN_NAME,
  },
]

const ListContent = () => {
  const { t } = useTranslation()
  const location = useLocation()
  const isUserLoggedIn = useReactiveVar(isUserLoggedInVar)
  const subDomain = useReactiveVar(appSubdomainVar)
  const [anchorEl, setAnchorEl] = useState(null)

  const handleToggle = event => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  if (location.pathname !== '/login')
    return (
      isUserLoggedIn && (
        <div>
          <IconButton
            aria-label="list-menu"
            aria-controls="menu-appbar-list"
            aria-haspopup="true"
            onClick={handleToggle}
            color="inherit"
          >
            <Icon children={'view_list'} />
          </IconButton>
          <Menu
            id="menu-appbar-list"
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            keepMounted
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            onClose={handleClose}
          >
            {listRoutes.map((item, key) => {
              if (subDomain === item.subDomain || !item.subDomain)
                return (
                  <MenuItem key={key}>
                    <Link href={item.href}>{t(item.title)}</Link>
                  </MenuItem>
                )
              else return null
            })}
          </Menu>
        </div>
      )
    )
  else return null
}

export default ListContent
